module.exports = __webpack_public_path__ + "static/media/SappaPatternGreen.786060ad.jpg";